import { ChevronDown } from "lucide-react";
import './commissionchart.css'
export default function AnalyticsCommissionChart() {
  return (
    <div className="rp-analytics-chart-card">
      
      {/* HEADER */}
      <div className="rp-analytics-chart-header">
        <h3 className="rp-analytics-chart-title">
          Commission Earnings
        </h3>

        <button className="rp-analytics-chart-filter">
          Last 6 Months
          <ChevronDown size={16} />
        </button>
      </div>

      {/* CHART */}
      <div className="rp-analytics-chart-wrapper">
        <svg
          viewBox="0 0 500 220"
          className="rp-analytics-line-chart"
          preserveAspectRatio="none"
        >
          {/* GRID */}
          <line x1="0" y1="40" x2="500" y2="40" />
          <line x1="0" y1="90" x2="500" y2="90" />
          <line x1="0" y1="140" x2="500" y2="140" />
          <line x1="0" y1="190" x2="500" y2="190" />

          {/* LINE */}
          <polyline
            points="0,150 80,110 160,130 240,80 320,100 400,50"
          />

          {/* POINTS */}
          {[
            [0,150],
            [80,110],
            [160,130],
            [240,80],
            [320,100],
            [400,50]
          ].map(([x, y], i) => (
            <circle key={i} cx={x} cy={y} r="4" />
          ))}
        </svg>
      </div>

      {/* LABELS */}
      <div className="rp-analytics-chart-labels">
        <span>Jan</span>
        <span>Feb</span>
        <span>Mar</span>
        <span>Apr</span>
        <span>May</span>
        <span>Jun</span>
      </div>

    </div>
  );
}
